import { render } from "./PremiumFeatureHint.vue?vue&type=template&id=531ce8c4"
import script from "./PremiumFeatureHint.vue?vue&type=script&lang=js"
export * from "./PremiumFeatureHint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__